module.exports = __webpack_public_path__ + "img/milestone__1928.deb3dbe6.jpg";